import { Unit } from '@data/unit/Unit';
import { doesUnitHaveOpenTime } from '@utilities/doesUnitHaveOpenTime';

export const getUnitsWithOpenTime = (units: Unit[]) => {
	return units.filter(doesUnitHaveOpenTime);
};
